var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.videoParam.filePath,"controls":"","autoplay":"","muted":""},domProps:{"muted":true},on:{"ended":function($event){return _vm.playNext()}}},[_vm._v("\n  您的浏览器不支持视频播放\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e51c1fc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/lib/showMoudle/eleVideos.vue
// module id = 47
// module chunks = 0